<template>
    <section class="video-sec5">
        <h2>انواع تبلیغات ویدیویی در آن کلیک</h2>
        <div class="video-sec5-content">
            <div class="video-sec5-txt">
                <div class="video-sec5-border"></div>
                <div class="video-sec5-main">
                    <swiper
                    :modules="[Autoplay, Pagination, Parallax]"

                    :pagination="{
                    clickable: true
                    }"
                    :loop="true"
                    :parallax="true"
                    :grabCursor="true"
                    class="video-sec5-swiper"
                    >
                        <swiper-slide v-for="(slide, index) in slides" :key="index">
                            <div class="video-sec5-card">
                                <h3  data-swiper-parallax="-100">{{ slide.title }}</h3>
                                <p data-swiper-parallax="-30">{{ slide.text }}</p>
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>
            </div>
            <img v-if="width > 768" src="../assets/images/videoAd-pic9.png" class="video-sec5-img" />
        </div>
    </section>
</template>

<script>
import { Autoplay, Pagination, Parallax } from 'swiper/modules'
import { ref, inject } from 'vue';
export default {
    name: "VideoSection5",
    setup() {
        const width = inject('viewportWidth');

        const slides = ref([
          {
            title: 'تبلیغات پری رول',
            text: 'تبلیغ پری رول به دلیل موقعیت استراتژیک و تاثیرگذاری بالا، به عنوان معروف ترین نوع تبلیغ ویدیویی شناخته می شود. کاربران حداقل ۵ ثانیه از تبلیغ را مشاهده می کنند و سپس امکان رد کردن تبلیغ و مشاهده ویدیوی اصلی را دارند. این ساختار به برندها این امکان را می دهد که پیام خود را در همان لحظات ابتدایی، با دقت بالا و تاثیرگذاری بیشتر به مخاطبان منتقل کنند.'
          },
          {
            title: 'تبلیغات میدرول',
            text: 'تبلیغ ویدیویی میدرول نوعی تبلیغ است که قابلیت نمایش در بخش های مختلف ویدیو (از ابتدا تا انتها) را دارد. این تبلیغ کوتاه است و پس از ۵ ثانیه امکان رد کردن آن وجود دارد.'
          },
        ]);

        return {
            width,
            slides,
            Autoplay,
            Pagination,
            Parallax
        }
    }
};
</script>

<style>
.video-sec5 {
    margin-inline: 13.06%;
    padding-bottom: 7px;
}

.video-sec5 h2 {
    font-family: 'IRANYekan-Bold';
    font-size: 28px;
    line-height: 38px;
    text-align: center;
    margin-bottom: 6.68%;
}

.video-sec5-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.video-sec5-txt {
    width: 50.76%;
    max-width: 540px;
    height: 380px;
    position: relative;
}

.video-sec5-txt,
.video-sec5-border,
.video-sec5-main,
.video-sec5-img {
     border-radius: 50px;
}

.video-sec5-border {
    transform: rotate(-2deg);
}

.video-sec5-border:before {
    content: "";
    position: absolute;
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    z-index: -1;
    background: linear-gradient(#F8BBD0 0%, #FFFFFF 50%, #F8BBD0 100%);
    border-radius: 50px;
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    mask-composite: exclude;
    -webkit-mask-composite: destination-out;
    padding: 1px;
}

.video-sec5-border,
.video-sec5-main {
    width: 100%;
    height: 100%;
}

.video-sec5-main {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10.9% 5.7%;
    background-color: #FFFFFF;
    position: absolute;
    top: 0;
}

.video-sec5-main,
.video-sec5-img {
    box-shadow: 0 2px 10px var(--shadow-light);
}

.video-sec5-img {
    width: 42.21%;
    aspect-ratio: 449 / 366;
    max-width: 449px;
    max-height: 366px;
}

.video-sec5-card h3 {
    font-family: 'IRANYekan-Bold';
    font-size: 24px;
    line-height: 28px;
    margin-bottom: 3.35%;
}

.video-sec5-card h3,
.video-sec5-card p {
    text-align: justify;
}

.video-sec5-card p {
     line-height: 26px;
}

.swiper-pagination {
    position: unset !important;
    margin-top: 3.35%;
}

.swiper-pagination-bullet-active {
    background-color: #393939ad !important;
    width: 14px !important;
    border-radius: 20px !important;
}

@media screen and (min-width:1441px) {
    .video-sec5 {
        width: 1064px;
        margin-inline: auto;
    }
}

@media screen and (max-width: 1024px) {
     .video-sec5 {
         margin-inline: 5.556%;
     }

    .video-sec5 h2 {
        font-size: 24px;
        line-height: 28px;
    }

    .video-sec5-txt {
        height: 360px;
    }

    .video-sec5-img {
        width: 40.21%;
    }

    .video-sec5-card h3 {
        font-size: 22px;
    }

    .video-sec5-card p {
     font-size: 16px;
    }
}

@media screen and (max-width: 768px) {
    .video-sec5 {
        margin-inline: 5.9%;
    }

    .video-sec5 h2 {
        margin-bottom: 26px;
    }

    .video-sec5-content {
        justify-content: center;
    }

    .video-sec5-txt {
        width: 100%;
    }
}

@media screen and (max-width: 375px) {
    .video-sec5 h2 {
        font-size: 20px;
    }

    .video-sec5-card h3 {
        font-size: 18px;
    }

    .video-sec5-card p {
     font-size: 14px;
     line-height: 24px;
    }
}
</style>